/**
 *  할부원금 월납입금 산출 계산식
 * @param {number} price 할부원금
 * @param {number} term 개월
 * @param {number} rate 금리
 * @returns 월납입금
 */
export const monthlyPriceCalculator = (price: number, term: number, rate: number): number => {
  // 금리를 소수점으로 표현
  const rating: number = rate / 100;

  // 원금균등 상환 방식 계산식
  const installment: number = price * (rating / 12);
  const secondInstallment: number = Math.pow(1 + rating / 12, term);

  return (installment * secondInstallment) / (secondInstallment - 1);
};
